module.exports = __webpack_public_path__ + "img/党建园地.5ad48a81.png";